
<template>
	<div class="no_auth_tip" :class="{hidden: hide}">
		<div>网络请求异常，请重新登陆</div>
		<div>将在<span class="seconds">{{num}}秒</span>后返回首页！</div>
	</div>
</template>
<script>
	import ajax from "@/api/ajax"
	import {delCookie, getQueryString} from '@/util/util'
	export default {
		data(){
			return{
				hide:true,
				num:3
			}
		},
		created() {
			if(getQueryString('waiting')==='true'){
				this.waitingLogOut();
			}else{
				this.logout();
			}
		},

		methods: {
			logout() {
				ajax.logout();
				delCookie('remember-me');
				delCookie('loginUser');
				this.$store.state.isLogin = false;
				window.location.href = '/mobile/cn/sc/';
			},

			waitingLogOut(){
				this.hide = false;
				this.interval = setInterval(()=>{
					this.num--;
					if(this.num === 0){
						this.logout();
					}
				},1000);
			}
		}
	}
</script>

<style scoped>
	.no_auth_tip{
		text-align: center;
		padding: 65% 20%;
		background: url(../../assets/images/waybill/sf-empty.png) no-repeat center 1.6rem;
		background-size: 3rem 3rem;
	}
	.no_auth_tip.hidden{
		display: none;
	}
	.seconds{
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/pages/logout/index.vue